import { Link } from "react-router-dom";

export function Footer({ t }) {
  return (
    <footer className="site-footer">
      <div className="wrap footer-inner">
        <div className="footer-top">
          <div>
            <strong className="footer-brand">Mezzbridge</strong>
            {t.footer.service}
            <br />
            {t.footer.line1}
            <br />
            {t.footer.line2}
          </div>
          <div className="footer-links" data-testid="footer-links">
            {t.footer.links.map((l) => (
              <Link key={l.to} to={l.to} data-testid={`footer-link-${l.to.replace("/", "")}`}>
                {l.label}
              </Link>
            ))}
          </div>
        </div>
        <p className="footer-disclaimer">{t.footer.disclaimer}</p>
      </div>
    </footer>
  );
}
